var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowV2 = function SvgLeftArrowV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M13.93 18.471a.741.741 0 0 0 1.05-1.045L9.59 12.005l5.393-5.431A.74.74 0 1 0 13.93 5.53L8.2 11.3a1 1 0 0 0 0 1.41z"
  })));
};
export default SvgLeftArrowV2;